// extracted by mini-css-extract-plugin
module.exports = {"container":"TabData_container__2Ty4f","header":"TabData_header__rIL33","tabes":"TabData_tabes__2RuGp","content":"TabData_content__2xGtt"};